import { createUseStyles } from "react-jss";
import { colors } from "constants/colors";
import { breakpoints } from "constants/breakpoints";

const styles = createUseStyles((theme) => ({
  benefitsWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    padding: "24px",
    position: "relative",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      padding: "14px",
    },
  },
  benefitsCard: {
    "& h6": {
      fontSize: "18px",
      fontWeight: "600",
      lineHeight: "28px",
      color: colors.lightBlack,
      marginBottom: "4px",
      marginRight: "12px",
    },
    "& p": {
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "20px",
      color: colors.mediumGrey,
      marginBottom: "0px",
    },
  },
  cardsWrapper: {
    display: "flex",
    flexWrap: "wrap",
    gap: "24px",
    marginTop: "16px",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      gap: "14px",
    },
  },
  cardBox: {
    backgroundColor: colors.brightBlue,
    padding: "24px",
    borderRadius: "16px",
    width: "286px",
    display: "flex",
    flexDirection: "column",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      width: "100%",
    },
    "& h6": {
      fontSize: "20px",
      fontWeight: "600",
      lineHeight: "30px",
      color: colors.lightBlack,
      marginTop: "32px",
      marginBottom: "8px",
    },
    "& p": {
      fontSize: "16px",
      fontWeight: "400",
      lineHeight: "24px",
      color: colors.mediumGrey,
      marginBottom: "0px",
      flexGrow: "1",
    },
  },
  activeIcon: {
    "& svg": {
      "& rect": {
        fill: theme.colors.primary,
      },
    },
  },
  lockedIcon: {
    "& svg": {
      "& > rect": {
        fill: theme.colors.primary,
      },
      "& g": {
        stroke: colors.white,
      },
    },
  },
  link: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    color: theme.buttons.defaultLink.color,
    fontSize: "16px",
    fontWeight: "600",
    lineHeight: "24px",
    textDecoration: "none",
    marginTop: "20px",
    width: "fit-content",
    "& path": {
      stroke: theme.buttons.defaultLink.color,
    },
  },
  divider: {
    width: "100%",
    color: colors.lightGrey,
    opacity: 1,
    margin: "0px",
  },
  footerItemWrapper: {
    padding: "24px",
    display: "flex",
    gap: "16px",
    "& path": {
      stroke: theme.buttons.defaultLink.color,
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      padding: "14px",
    },
  },
  footerItem: {
    "& h6": {
      fontSize: "18px",
      fontWeight: "600",
      lineHeight: "28px",
      color: colors.lightBlack,
      marginBottom: "8px",
    },
    "& p": {
      fontSize: "16px",
      fontWeight: "400",
      lineHeight: "24px",
      color: colors.mediumGrey,
      marginBottom: "0px",
    },
  },
  benefitsCardHeader: {
    display: "flex",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      flexDirection: "column",
    },
  },
  optInBtn: {
    height: "fit-content",
    width: "fit-content",
    position: "absolute",
    top: "24px",
    right: "24px",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      position: "static",
    },
    "& span": {
      display: "flex",
      gap: "8px",
      alignItems: "center",
    },
  },
  optInBtnPadding: {
    [`@media (min-width: ${breakpoints.sm}px)`]: {
      paddingRight: "120px",
    },
  },
  accordionBtn: {
    marginTop: "4px",
    flexShrink: "0",
    "& svg": {
      "& path": {
        fill: colors.darkBlue,
        stroke: colors.darkBlue,
        strokeWidth: 0.5,
      },
    },
  },
  tierUnavailableWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    maxWidth: "352px",
    margin: "0px auto",
    "& h6": {
      color: colors.lightBlack,
      marginBottom: "4px",
    },
    "& p": {
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "20px",
      color: colors.mediumGrey,
      marginBottom: "0px",
    },
  },
}));

export default styles;
